import { BaseApi } from "api/BaseApi";

import GetGlobalFormFieldsRequest = App.Http.Requests.GlobalFormField.GetGlobalFormFieldsRequest;
import GetGlobalFormFieldsResponse = App.Http.Responses.GlobalFormField.GetGlobalFormFieldsResponse;

class GlobalFormFieldApi extends BaseApi {
    async index(request: GetGlobalFormFieldsRequest): Promise<GetGlobalFormFieldsResponse> {
        return await this.get<GetGlobalFormFieldsResponse, GetGlobalFormFieldsRequest>("/global-form-fields", {
            params: request,
        });
    }
}

export const globalFormFieldApi = new GlobalFormFieldApi();
